export const EShapeActionValueShowHideType = wcardinal.ui.EShapeActionValueShowHideType;